import { Breadcrumbs } from "components/breadcrumbs";
import { BlogSubCategoryForm } from "./components";
import { useCreate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { IBlogSubCategoryForm } from "interfaces";
import { useNavigate } from "react-router-dom";

export const CreateBlogSubCategory: React.FC = () => {

  const { mutate, isLoading: isSubmitingSubCategoryForm } = useCreate();
  const navigate = useNavigate();

  const onSubmit = (values: IBlogSubCategoryForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "mkt/sub-categories",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
        },
      },
      {
        onSuccess: () => {
          toast.success("Create successfully");
          navigate(`/mkt/sub-category`);
        },
      }
    );
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Support Center Category" />
      <BlogSubCategoryForm onSubmit={onSubmit} />
      {isSubmitingSubCategoryForm ? <FullScreenLoading /> : <></>}
    </div>
  );
};
